import {Injectable} from '@angular/core';
import {Log, UserManager, UserManagerSettings} from "oidc-client";

@Injectable()
export class OidcService
{
  callbackUri(tenantName: string): string {
    let redirectUri = location.origin + "/oidc-callback";
    redirectUri += '?tenant=' + tenantName
    return redirectUri;
  }
  getUserManager(tenantSettings: any, tenantName: string): UserManager {
    const userManagerSettings: UserManagerSettings = {
      authority: location.origin + "/api/authenticateproxy/" + tenantName,
      client_id: tenantSettings.oidcClientId,
      client_secret: 'something_irrelevant_but_not_empty',
      response_type: 'code',
      scope: 'openid email',
      redirect_uri: this.callbackUri(tenantName),
      loadUserInfo: false
    };
    return new UserManager(userManagerSettings);
  }
}

